import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { TermsOfService } from 'experiences/terms'
import { LegalAgreement } from 'services/Directus/collections/legal_agreements'

interface Props {
	legalAgreement: LegalAgreement | null
}

const TOS: NextPage<PagePropsWrapper<Props>> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<TermsOfService />
	</StandardLayout>
)

export default TOS
